import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import { PVI_NO_STYLES_CLASSNAME } from 'utils/helpers/inclusion';
import styles from '../styles.module.scss';

const BackForwardControls = ({
	children,
	rewindBack,
	rewindForward,
	forwardButtonRef
}) => (
	<div className={styles.BackForwardControls}>
		<button
			type="button"
			className={styles.BackForwardControls__Button}
			onClick={rewindBack}
			onKeyDown={rewindBack}
			aria-label="Перемотка назад: 15 секунд"
			ref={forwardButtonRef}
		>
			<span className={styles.BackForwardControls__Value}>15</span>
			<Icon
				icon="audio-backButton"
				useClassName={PVI_NO_STYLES_CLASSNAME}
				className={PVI_NO_STYLES_CLASSNAME}
			/>
		</button>

		{children}

		<button
			type="button"
			className={styles.BackForwardControls__Button}
			onClick={rewindForward}
			onKeyDown={rewindForward}
			aria-label="Перемотка вперед: 15 секунд"
		>
			<span className={styles.BackForwardControls__Value}>15</span>
			<Icon icon="audio-forwardButton" />
		</button>
	</div>
);

BackForwardControls.propTypes = {
	children: PropTypes.element.isRequired,
	rewindBack: PropTypes.func.isRequired,
	rewindForward: PropTypes.func.isRequired,
	forwardButtonRef: PropTypes.object
};

export default BackForwardControls;
